import { useContext } from 'react';
import { ReportContext } from '../../../context/ReportContext';
import SimpleDataGrid from '../../Tables/SimpleDataGrid';
import SimpleDataGridItem from '../../Tables/SimpleDataGridItem';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserAiAggregate = () => {
    const { reportData } = useContext(ReportContext) || {};

    const messagesTotal = reportData?.messagesTotal;
    const conversationsTotal = reportData?.conversationsTotal;
    const popularTopics = reportData?.popularTopics;

    return (
        <div className="space-y-6">
            <SimpleDataGrid>
                <SimpleDataGridItem label="Total Messages:" value={messagesTotal} />
                <SimpleDataGridItem
                    label="Total Conversations:"
                    value={conversationsTotal}
                />
            </SimpleDataGrid>

            <div className="max-w-2xl">
                <h2 className="font-semibold text-slate-800 mb-2">
                    Top AI Conversation Topics
                </h2>
                {!popularTopics.length && (
                    <div className="text-sm text-gray-500 italic">
                        Not enough results with the selected filters.
                    </div>
                )}
                {popularTopics.length > 0 && (
                    <ol className="flex flex-wrap gap-2">
                        {popularTopics.map((topic, idx) => (
                            <li
                                key={topic + '_' + idx}
                                className="px-3 py-1 bg-slate-100 rounded-full text-sm font-medium border border-slate-200"
                            >
                                <span className="text-slate-800">{topic}</span>
                            </li>
                        ))}
                    </ol>
                )}
            </div>

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report provides an aggregate view of AI-powered conversations and
                    interactions within the platform for the selected time period and
                    filters.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Total Messages">
                    The total number of individual messages the users sent to the AI
                    assistant.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Total Conversations">
                    The total number of distinct conversation sessions initiated with the
                    AI assistant.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Top AI Conversation Topics">
                    The most frequently discussed topics in AI conversations,
                    automatically categorized based on conversation content.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserAiAggregate;
